import { currentLanguage } from "../../../algorithms/storage";
import axios from "../../axiosConfig";

export const addProcedureService = (taskId, data, token) => {
  return axios.post(`TaskProcedure/AddTaskProcedure/${taskId}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

// sub task comment
export const addSubTaskCommentService = (taskprocedureId, data, token) => {
  return axios.post(
    `SubTaskComment/AddTaskComment?taskprocedureId=${taskprocedureId}`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

export const addSubTaskProcedureService = (taskId, data, token) => {
  return axios.post(`SubTaskProcedure/AddSubTaskProcedure/${taskId}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getTaskMembers = (taskId, token) => {
  return axios.get(`TaskProcedure/GetTaskProcedureForm/${taskId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getProcedure = (porcId, token) => {
  return axios.get(`TaskProcedure/GetEditTaskProcedureForm/${porcId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getSubTaskProcedureForm = (porcId, token) => {
  return axios.get(`SubTaskProcedure/GetEditTaskProcedureForm/${porcId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const editProc = (data = {}, isActivityProc, token) => {
  if (isActivityProc)
    return axios.put(`ActivityProcedure/UpdateActivityProcedure`, data, {
      headers: {
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    });
  else
    return axios.put(`TaskProcedure/UpdateTaskProcedure`, data, {
      headers: {
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    });
};
export const editProcStatus = (procId, statusId, token) => {
  return axios.put(
    `TaskProcedure/SetTaskProcedureStatus/${procId}/${statusId}`,
    {
      headers: {
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

export const deleteProc = (procId, token) => {
  return axios.delete(`TaskProcedure/DeleteTaskProcedure/${procId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};
